import React from 'react'
import { motion } from "framer-motion"
import {
  containerAnimation,
  childAnimation,
  imageAnimation,
  fastAnimation,
  fastContainerAnimation,
  lineAnimation,
  hoverAnimation
} from '../data/animations'


const UMega = () => {
  return (
    <div className='overflow-hidden'>


      <div className=' max-h-[calc(100vh-6rem)] overflow-hidden w-full p-2.5 md:p-5 !pt-0 overflow-hidden mb-2.5 md:mb-5'>
        <motion.div
          className=' w-full h-[calc(100vh-6rem)]  relative overflow-hidden bg-[#c1cacf]'
          initial="initial"
          animate="animate"
          viewport={{ once: false, amount: 0 }}
          variants={containerAnimation}
        >
          {/* Mobil resim */}
          <motion.img
            src='/images/u-mega/1-mobil.png'
            className='h-full w-full object-cover object-[50%_100%] block md:hidden'
            variants={imageAnimation}
          />
          {/* Desktop resim */}
          <motion.img
            src='/images/u-mega/1.png'
            className='h-full w-full object-cover object-[50%_40%] hidden md:block'
            variants={imageAnimation}
          />


          <div className='absolute bottom-0 left-0 w-full h-1/3  bg-[linear-gradient(to_top,_#4d4d4d_0%,_#4d4d4d_17%,_transparent_100%)] '></div>
          <div className='absolute top-0 left-0 h-full w-full  flex flex-col  md:justify-between z-20 px-5 md:px-0 b'>
            <div className='flex justify-center items-center pt-16'>
              <motion.div
                className='relative flex flex-col items-center w-2/3  text-white'
                variants={childAnimation}
              >
                <motion.img
                  src='/images/u-mega/u-mega-black-logo.svg'
                  className='w-full md:w-80 mb-8'
                  variants={childAnimation}
                />
                <div className='font-medium  lg:text-16 text-[#333333] font-montserrat  tracking-[0.4rem] text-center'>
                  YENİ NESİL ÜRETİM VE YATIRIM ALANI
                </div>

              </motion.div>
            </div>

            <div className=' mb-16 md:mb-0 space-y-3 md:space-y-0  flex flex-col items-center md:flex-row md:justify-end md:items-start w-full   md:px-28 '>

              <motion.h6
                className='w-full md:w-2/3 hidden md:block text-[#e6e6e6] md:text-base font-semibold lg:text-24 font-montserrat leading-tight md:pr-12 pb-6 md:text-end mt-4 lg:mt-8'
                variants={childAnimation}
              >
                ŞEHRİN MERKEZİNE YAKINLIĞI,
                SANAYİNİN KALBİNDEKİ KONUMUYLA U MEGA
              </motion.h6>
              <div className='w-1/3 block md:hidden'>

                <motion.img
                  src='/images/u-mega/ulus-insaat-guvencesiyle-black.svg '
                  className='w-full md:w-64 mb-8 mt-6'
                  variants={childAnimation}
                />
              </div>




              <motion.div
                className='relative w-[40%] md:w-36 lg:w-56 align-bottom flex-none flex  items-end h-auto md:h-full'
                variants={childAnimation}
              >
                <img src='/images/u-mega/line-ulus-insaat-guvencesiyle-white.svg' className='w-full hidden md:block' />

              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>



      <div className=' min-h-screen h-screen md:h-[calc(100vh-8rem)] w-full p-2.5 md:p-5 !pt-0'>
        <motion.div
          className=' w-full h-full relative overflow-hidden bg-[#c1cacf]'
          initial="initial"
          whileInView="animate"
          viewport={{ once: false, amount: 0 }}
          variants={containerAnimation}
        >
          <motion.img
            src='/images/u-mega/2.jpg'
            className='h-full w-full  md:w-full object-cover  object-bottom '
            variants={imageAnimation}
          />

          <div className='absolute bottom-0 left-0 w-full h-3/5  bg-[linear-gradient(to_top,_#4d4d4d_0%,_#4d4d4d_17%,_transparent_100%)] '></div>
          <div className='absolute top-0 left-0 h-full w-full  flex flex-col justify-between z-20 px-5 md:px-0 b'>
            <div className='flex justify-center items-center pt-10'>

            </div>

            <div className=' mb-16 md:mb-0 space-y-3 md:space-y-0  flex flex-col items-center md:flex-row md:justify-end md:items-start w-full   md:px-28 '>

              <motion.h6
                className='w-full md:w-2/3 text-[#e6e6e6] md:text-base font-semibold lg:text-24 font-montserrat leading-tight md:pr-12 pb-6 md:text-end mt-4 lg:mt-8'
                variants={childAnimation}
              >
                <span className='!block text-[#ff931e] '>MERKEZİN İÇİNDE, MERKEZİNDE SİZ VARSINIZ</span>
                ULUS İNŞAAT GÜVENCESİYLE HAYATA GEÇİRİLEN U MEGA, ŞEHİRLE SANAYİYİ
                BULUŞTURAN VİZYONER BİR PROJEDİR.
                MODERN YAPISI VE STRATEJİK KONUMUYLA
                İŞ DÜNYASININ YENİ MERKEZİ OLMAYA ADAY.
              </motion.h6>



              <motion.div
                className='relative w-[40%] md:w-36 lg:w-56 align-bottom flex-none flex  items-end h-auto md:h-full'
                variants={childAnimation}
              >
                <img src='/images/u-mega/l-u-mega-w.svg' className='w-full hidden md:block' />
                <img src='/images/u-mega/u-mega-w.svg' className='w-full block md:hidden' />
              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>



      <div className=' min-h-screen h-screen md:h-[calc(100vh-8rem)] w-full p-2.5 md:p-5 !pt-0'>
        <motion.div
          className=' w-full h-full relative overflow-hidden bg-[#c1cacf]'
          initial="initial"
          whileInView="animate"
          viewport={{ once: false, amount: 0 }}
          variants={containerAnimation}
        >
          <motion.img
            src='/images/u-mega/3.jpg'
            className='h-full w-full  md:w-full object-cover  object-bottom '
            variants={imageAnimation}
          />

          <div className='absolute bottom-0 left-0 w-full h-3/5  bg-[linear-gradient(to_top,_#4d4d4d_0%,_#4d4d4d_17%,_transparent_100%)] '></div>
          <div className='absolute top-0 left-0 h-full w-full  flex flex-col justify-between z-20 px-5 md:px-0 b'>
            <div className='flex justify-center items-center pt-10'>

            </div>

            <div className=' mb-16 md:mb-0 space-y-3 md:space-y-0  flex flex-col items-center md:flex-row md:justify-end md:items-start w-full   md:px-28 '>

              <motion.h6
                className='w-full md:w-2/3 text-[#e6e6e6] md:text-base font-semibold lg:text-24 font-montserrat leading-tight md:pr-12 pb-6 md:text-end mt-4 lg:mt-8'
                variants={childAnimation}
              >
                <span className='!block text-[#ff931e] '>KÂRLI, FONKSİYONEL, GELECEĞE DÖNÜK.</span>
                PERAKENDE SEKTÖRÜNDEN LOJİSTİK FİRMALARINA, BİREYSEL
                YATIRIMCILARDAN KURUMSAL İŞLETMELERE KADAR GENİŞ BİR
                HEDEF KİTLEYE HİTAP EDEN U MEGA, YÜKSEK KİRA GETİRİSİ VE
                YATIRIM DEĞERİ İLE DİKKAT ÇEKİYOR.
              </motion.h6>

              <motion.div
                className='relative w-[40%] md:w-36 lg:w-56 align-bottom flex-none flex  items-end h-auto md:h-full'
                variants={childAnimation}
              >
                <img src='/images/u-mega/l-u-mega-w.svg' className='w-full hidden md:block' />
                <img src='/images/u-mega/u-mega-w.svg' className='w-full block md:hidden' />
              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>



      <div className=' min-h-screen h-screen md:h-[calc(100vh-8rem)] w-full p-2.5 md:p-5 !pt-0'>
        <motion.div
          className=' w-full h-full relative overflow-hidden bg-[#c1cacf]'
          initial="initial"
          whileInView="animate"
          viewport={{ once: false, amount: 0 }}
          variants={containerAnimation}
        >
          <motion.img
            src='/images/u-mega/4.jpg'
            className='h-full w-full  md:w-full object-cover  object-bottom '
            variants={imageAnimation}
          />

          <div className='absolute bottom-0 left-0 w-full h-3/5  bg-[linear-gradient(to_top,_#4d4d4d_0%,_#4d4d4d_17%,_transparent_100%)] '></div>
          <div className='absolute top-0 left-0 h-full w-full  flex flex-col justify-between z-20 px-5 md:px-0 b'>
            <div className='flex justify-center items-center pt-10'>

            </div>

            <div className=' mb-16 md:mb-0 space-y-3 md:space-y-0  flex flex-col items-center md:flex-row md:justify-end md:items-start w-full   md:px-28 '>

              <motion.h6
                className='w-full md:w-2/3 text-[#e6e6e6] md:text-base font-semibold lg:text-24 font-montserrat leading-tight md:pr-12 pb-6 md:text-end mt-4 lg:mt-8'
                variants={childAnimation}
              >
                <span className='!block text-[#ff931e] '>HER DETAYIYLA HAZIR, HER İHTİYACA UYGUN</span>
                YÜKSEK TAVANLI, GENİŞ HACİMLİ, GÜN IŞIĞI ALAN
                İÇ MEKANLARELEKTRİK, SU VE ALTYAPI SİSTEMLERİ BİRİNCİ SINIF
                KALİTEDE. HEM ÜRETİM HEM DE TİCARET İÇİN İDEAL ZEMİN.
              </motion.h6>

              <motion.div
                className='relative w-[40%] md:w-36 lg:w-56 align-bottom flex-none flex  items-end h-auto md:h-full'
                variants={childAnimation}
              >
                <img src='/images/u-mega/l-u-mega-w.svg' className='w-full hidden md:block' />
                <img src='/images/u-mega/u-mega-w.svg' className='w-full block md:hidden' />
              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>











      <div className=' min-h-screen h-screen md:h-[calc(100vh-8rem)] w-full p-2.5 md:p-5 !pt-0'>
        <motion.div
          className=' w-full h-full relative overflow-hidden bg-[#c1cacf]'
          initial="initial"
          whileInView="animate"
          viewport={{ once: false, amount: 0 }}
          variants={containerAnimation}
        >
          <motion.img
            src='/images/u-mega/2.jpg'
            className='h-full w-full  md:w-full object-cover  object-bottom '
            variants={imageAnimation}
          />

          <div className='absolute bottom-0 left-0 w-full h-3/5  bg-[linear-gradient(to_top,_#4d4d4d_0%,_#4d4d4d_17%,_transparent_100%)] '></div>
          <div className='absolute top-0 left-0 h-full w-full  flex flex-col justify-between z-20 px-5 md:px-0 b'>
            <div className='flex justify-center items-center pt-10'>

            </div>

            <div className=' mb-16 md:mb-0 space-y-3 md:space-y-0  flex flex-col items-center md:flex-row md:justify-end md:items-start w-full   md:px-28 '>

              <motion.h6
                className='w-full md:w-2/3 text-[#e6e6e6] md:text-base font-semibold lg:text-24 font-montserrat leading-tight md:pr-12 pb-6 md:text-end mt-4 lg:mt-8'
                variants={childAnimation}
              >
                <span className='!block text-[#ff931e] '>GÜVENLE ÜRETİN, GÖNÜL RAHATLIĞIYLA DEĞERLENDİRİN.</span>
                DEPREME DAYANIKLI YAPISI, MODERN GÜVENLİK SİSTEMLERİ VE TÜM YASAL
                PROSEDÜRLERE TAM UYGUNLUĞU İLE U MEGA, UZUN VADELİ VE GÜVENLİ
                BİR YATIRIM FIRSATI SUNUYORUZ.
              </motion.h6>

              <motion.div
                className='relative w-[40%] md:w-36 lg:w-56 align-bottom flex-none flex  items-end h-auto md:h-full'
                variants={childAnimation}
              >
                <img src='/images/u-mega/l-u-mega-w.svg' className='w-full hidden md:block' />
                <img src='/images/u-mega/u-mega-w.svg' className='w-full block md:hidden' />
              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>







      <div className=' min-h-screen h-screen md:h-[calc(100vh-8rem)] w-full p-2.5 md:p-5 !pt-0'>
        <motion.div
          className=' w-full h-full relative overflow-hidden bg-[#c1cacf]'
          initial="initial"
          whileInView="animate"
          viewport={{ once: false, amount: 0 }}
          variants={containerAnimation}
        >
          <motion.img
            src='/images/u-mega/5.jpg'
            className='h-full w-full  md:w-full object-cover  object-bottom '
            variants={imageAnimation}
          />

          <div className='absolute bottom-0 left-0 w-full h-3/5  bg-[linear-gradient(to_top,_#4d4d4d_0%,_#4d4d4d_17%,_transparent_100%)] '></div>
          <div className='absolute top-0 left-0 h-full w-full  flex flex-col justify-between z-20 px-5 md:px-0 b'>
            <div className='flex justify-center items-center pt-10'>

            </div>

            <div className=' mb-16 md:mb-0 space-y-3 md:space-y-0  flex flex-col items-center md:flex-row md:justify-end md:items-start w-full   md:px-28 '>

              <motion.h6
                className='w-full md:w-2/3 text-[#e6e6e6] md:text-base font-semibold lg:text-24 font-montserrat leading-tight md:pr-12 pb-6 md:text-end mt-4 lg:mt-8'
                variants={childAnimation}
              >
                <span className='!block text-[#ff931e] '>KOLAY ULAŞIM, ETKİN LOJİSTİK.</span>
                ULUS İNŞAAT GÜVENCESİYLE HAYATA GEÇİRİLEN U MEGA, ŞEHİRLE SANAYİYİ
                BULUŞTURAN VİZYONER BİR PROJEDİR. MODERN YAPISI VE STRATEJİK
                KONUMUYLA İŞ DÜNYASININ YENİ MERKEZİ OLMAYA ADAY.
              </motion.h6>

              <motion.div
                className='relative w-[40%] md:w-36 lg:w-56 align-bottom flex-none flex  items-end h-auto md:h-full'
                variants={childAnimation}
              >
                <img src='/images/u-mega/l-u-mega-w.svg' className='w-full hidden md:block' />
                <img src='/images/u-mega/u-mega-w.svg' className='w-full block md:hidden' />
              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>









      <div className='  w-full p-2.5 md:p-5 !pt-0'>

        <motion.div
          className='h-full md:min-h-[calc(100vh-8rem)] w-full  relative overflow-hidden  bg-[#333333] '
          initial="initial"
          whileInView="animate"
          viewport={{ once: false, amount: 0 }}
          variants={containerAnimation}
        >

          <div className='relative top-0 left-0 h-full w-full  flex flex-col justify-center z-20 px-[16.6%] md:px-0 '>
            <div className=' flex flex-col w-full h-full  justify-center items-center  space-y-12 '>
              <motion.div
                className='relative w-2/3 md:w-64  pt-36'
                variants={childAnimation}
              >
                <motion.img src='/images/u-mega/u-mega.svg' className='w-full' variants={childAnimation} />

              </motion.div>


              <motion.h6
                className='w-full md:w-2/3 text-[#e6e6e6] md:text-base font-semibold lg:text-24 font-montserrat leading-tight md:pr-12 pb-6 text-center mt-4 lg:mt-8'
                variants={childAnimation}
              >
                SINIRLI SAYIDA KALAN BU AYRICALIKLI ALANLAR İÇİN GEÇ KALMAYIN.<br />
                HEMEN BİZİMLE İLETİŞİME GEÇİN.
              </motion.h6>

              <motion.div
                className=' flex flex-col items-center justify-center space-y-10'
              >
                <motion.div
                  className='relative flex-none font-adobe border text-center border-[#e6e6e6] leading-tight py-2 px-10 text-[#e6e6e6]'
                  variants={childAnimation}
                >
                  <motion.p className='text-24 md:text-35 font-medium' variants={childAnimation}>Detaylı Bilgi İçin</motion.p>
                  <motion.a href='tel:05066500602' target='_blank' className='block text-28 md:text-45 font-bold' variants={childAnimation} whileHover={hoverAnimation.whileHover}>0506 650 06 02</motion.a>
                  <motion.a href='https://www.ulus.co' target='_blank' className='block text-24 md:text-35 leading-none mb-0.5' variants={childAnimation} whileHover={hoverAnimation.whileHover}>www.ulus.co</motion.a>

                </motion.div>

              </motion.div>

              <motion.div
                className='relative w-2/3 md:w-56 pb-20 '
                variants={childAnimation}
              >
                <motion.img src='/images/projects/house/logo-guvence-ulus.svg' className='w-full' variants={childAnimation} />
                <motion.img src='/images/projects/house/logo-guvence-ulus-text.svg' className='w-full absolute top-0' variants={childAnimation} />
              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  )
}

export default UMega